<template>
    <div class="main">
        <div :class="['header_back']">
            <div class="back_icon" @click.stop="goback">
                <span></span>
            </div>
            {{ $route.meta.title }}
        </div>
        <div class="back_warp">
            <div class="main-home">
                <img
                    @click="goHome"
                    src="@/assets/images/user/house/home-jg.png"
                    alt=""
                />
            </div>
            <!-- 未评价页面  -->
            <template v-if="additional_evaluation == 0">
                <template v-if="showInfo == 2">
                    <share :isFixed="isFixed" />
                </template>
                <template v-else>
                    <!-- 底部提交按钮 -->
                    <div class="submit">
                        <div class="submit-checkout">
                            <van-checkbox
                                icon-size="15px"
                                checked-color="#ffffff"
                                shape="square"
                                v-model="anonymous_show"
                            >
                                同意匿名展示评价/工地现场图片</van-checkbox
                            >
                            <van-icon
                                @click="notice = true"
                                class="icon"
                                size="15"
                                color="#CCCCCC"
                                name="question"
                            />
                        </div>
                        <div @click="submit" class="submit-btn">提交</div>
                    </div>
                </template>
                <!-- 主体部分 -->
                <div class="main-content">
                    <div class="main-content-explain">
                        非常感谢您对A.O.史密斯的信任和支持，您的冷暖风水系统产品已经全部安装并调试完毕，现场验收合格还请您验收。
                    </div>
                    <div class="check-agree">
                        <van-checkbox
                            style="margin-left: auto"
                            checked-color="#355D4B"
                            shape="square"
                            v-model="isAgree"
                        >
                            我已阅读并确认全部验收合格</van-checkbox
                        >
                    </div>
                    <div class="underline"></div>
                    <div class="main-content-hint">
                        <div class="hing-img"></div>
                        <span
                            >您的评价/工地现场图片能帮助其他人更真实的了解产品~</span
                        >
                    </div>
                    <!-- 五星评价-->
                    <template v-for="(item, index) of evaluateTag">
                        <div
                            :key="index"
                            class="main-content-instructions mt48"
                        >
                            <!-- 说明 -->
                            <div class="declare">
                                {{ index + 1 }}.{{ item.title }}
                            </div>
                            <!-- 五星 -->
                            <div class="five-stars">
                                <van-rate
                                    color="#FCBF82"
                                    size="0.58rem"
                                    @change="rates(index, item.id)"
                                    void-icon="star"
                                    void-color="#DDDDDD"
                                    v-model="evaluateStar[index]"
                                    :readonly="showInfo == 2 ? true : false"
                                />
                                <span>{{ evaluateStar[index] }}分</span>
                            </div>
                            <!-- 标签 -->
                            <div v-if="evaluateStar[index]" class="label">
                                <template
                                    v-for="(items, indexs) of evaluateTag[index]
                                        .tags[evaluateStar[index]]"
                                >
                                    <span
                                        :style="
                                            items.style
                                                ? 'background:#EAEEED;color:#355D4B;font-weight:bold'
                                                : ''
                                        "
                                        :key="indexs"
                                        @click="selectTag(index, items.id)"
                                    >
                                        {{ items.title }}
                                    </span>
                                </template>
                            </div>
                        </div>
                    </template>
                    <!-- 评价 -->
                    <div class="text-voice-evaluate">
                        <div class="text-voice-evaluate-title">
                            <span
                                @click="text_voice = 0"
                                :style="text_voice == 0 ? 'color:#333333' : ''"
                                >文字评价</span
                            >
                            <!-- <span
                                @click="text_voice = 1"
                                :style="text_voice == 1 ? 'color:#333333' : ''"
                                >语音评价</span
                            > -->
                        </div>
                        <!-- 文字评价 -->
                        <div
                            v-if="text_voice == 0"
                            class="text-voice-evaluate-content text-voice-evaluate-content-before"
                        >
                            <textarea
                                maxlength="-1"
                                class="text no-resize"
                                :placeholder="nProjectType==2?'您可以从空气温度、湿度、新鲜度、洁净度、运行声音五个维度，或不同房间、不同家庭成员使用体验进行评价，也可对系统节能性、操控性、售后服务等方面进行评价...':'您可以从空调、采暖、新风（如已购）使用体验，系统节能性、操控性，售后服务等方面进行评价...'"
                                v-model.trim="sContent"
                                :disabled="showInfo == 2 ? true : false"
                            ></textarea>
                        </div>
                        <!-- 语音评价 -->
                        <div v-else class="text-voice-evaluate-content">
                            <!-- 点击录制语音 -->
                            <div v-if="!BshowToast" class="recording-voice">
                                <div
                                    @click="clickRecord"
                                    class="recording-voice-btn"
                                ></div>
                                <span>{{
                                    status == "start"
                                        ? "点击结束录制"
                                        : "点击录制评价语音"
                                }}</span>
                            </div>
                            <!-- 点击试听录制语音 -->
                            <div v-else @click="Audition" class="play-voice">
                                <div class="play-voice-fish"></div>
                                <span class="">{{ voice_time }}s</span>
                                <span @click="delete_voicl" class="delete"
                                    >删除</span
                                >
                                <span class="wire">|</span>
                                <div class="voice-icon"></div>
                                <div class="play-voice-text">
                                    点击试听录制语音
                                </div>
                                <audio
                                    ref="audioRef"
                                    class="audio-ref"
                                    :src="sAudioUrl"
                                />
                            </div>
                        </div>
                    </div>
                    <!-- 图片上传 -->
                    <div class="image-uploading">
                        <div class="image-uploading-title">
                            <span> 图片/视频上传</span>
                            <div class="photo-img" @click="openPhoto">
                                <span>照片示例</span>
                                <img src="@/assets/images/198.png" alt="">
                            </div>
                        </div>
                        <!-- 图片上传 -->
                        <!------------------开始------------------- 图片视频上传 -----------------------开始--------------------->
                        <div
                            class="addContent2"
                            style="margin-top: 0; padding: 0"
                        >
                            <div class="imgbox">
                                <div
                                    class="img-div"
                                    v-for="(item, index) in arrMedia"
                                    :key="index"
                                >
                                    <!-- 删除视频图片按钮 -->
                                    <img
                                        @click="deleImg(index)"
                                        class="delete-image"
                                        src="@/assets/images/image-delete.png"
                                    />
                                    <img
                                        v-if="item.type == 'image'"
                                        @click="
                                            handleImagePreview(arrMedia, index)
                                        "
                                        :src="item.url"
                                        alt=""
                                        class="img"
                                    />
                                    <video
                                        v-else
                                        @click="playVideo(item.url)"
                                        :src="item.url"
                                        alt=""
                                        :poster="
                                            item.url +
                                            '?x-oss-process=video/snapshot,t_1000,m_fast'
                                        "
                                        class="img"
                                    ></video>
                                    <div
                                        @click="playVideo(item.url)"
                                        v-if="item.type != 'image'"
                                        class="video-play"
                                    ></div>
                                </div>
                                <!-- 上传图片视频按钮 -->
                                <div class="img-div">
                                    <img
                                        @click="choiceImg"
                                        src="@/assets/images/user/house/add_image_video.png"
                                        alt=""
                                        class="img"
                                    />
                                </div>
                                <input
                                    style="display: none"
                                    @change="imageToBase64"
                                    ref="filElem"
                                    type="file"
                                    id="input"
                                    accept="image/*,video/*"
                                />
                                <div id="in-box" style="display: none"></div>
                            </div>
                        </div>
                        <!------------------结束------------------- 图片视频上传 -----------------------结束--------------------->
                    </div>
                </div>
            </template>
            <!-- 已经评价页面 -->
            <template v-if="additional_evaluation == 1">
                <template v-if="showInfo == 2">
                    <share :isFixed="isFixed" />
                </template>
                <template v-else>
                    <!-- 底部提交按钮 -->
                    <div class="submit hei180">
                        <div
                            @click="additional_evaluation = 2"
                            class="submit-btn additional"
                        >
                            追加评价
                        </div>
                    </div>
                </template>
                <!-- 主体部分 -->
                <div class="main-content">
                    <div class="main-content-explain">
                        非常感谢您对A.O.史密斯的信任和支持，您的冷暖风水系统产品已经全部安装并调试完毕，现场验收合格还请您验收。
                    </div>
                    <div class="check-agree">
                        <van-checkbox
                            style="margin-left: auto"
                            checked-color="#355D4B"
                            shape="square"
                            v-model="trues"
                            disabled
                            >我已阅读并确认全部验收合格</van-checkbox
                        >
                    </div>
                    <div class="underline"></div>
                    <div class="main-content-hint">
                        <div class="hing-img"></div>
                        <span
                            >您的评价/工地现场图片能帮助其他人更真实的了解产品~</span
                        >
                    </div>
                    <!-- 五星评价-->
                    <template v-for="(item, index) of evaluateTag">
                        <div
                            :key="index"
                            class="main-content-instructions mt48"
                        >
                            <!-- 说明 -->
                            <div class="declare">
                                {{ index + 1 }}.{{ item.title }}
                            </div>
                            <!-- 五星 -->
                            <div class="five-stars">
                                <van-rate
                                    color="#FCBF82"
                                    readonly
                                    size="0.58rem"
                                    @change="rates(index, item.id)"
                                    void-icon="star"
                                    void-color="#DDDDDD"
                                    v-model="evaluateStar[index]"
                                />
                                <span>{{ evaluateStar[index] }}分</span>
                            </div>
                            <!-- 标签 -->
                            <div v-if="evaluateStar[index]" class="label">
                                <template
                                    v-for="(items, indexs) of evaluateTag[index]
                                        .tags[evaluateStar[index]]"
                                >
                                    <span
                                        v-if="items.style"
                                        :style="
                                            items.style
                                                ? 'background:#EAEEED;color:#355D4B;font-weight:bold'
                                                : ''
                                        "
                                        :key="indexs"
                                    >
                                        {{ items.title }}
                                    </span>
                                </template>
                            </div>
                        </div>
                    </template>
                    <!-- 评价 -->
                    <div
                        class="text-voice-evaluate"
                        v-if="text_show || voice_show"
                    >
                        <div class="text-voice-evaluate-title">
                            <span
                                @click="text_show = 0"
                                v-if="text_show"
                                :style="text_voice == 0 ? 'color:#333333' : ''"
                                >文字评价</span
                            >
                            <!-- <span
                                @click="text_show = 1"
                                v-if="voice_show"
                                :style="text_voice == 1 ? 'color:#333333' : ''"
                                >语音评价</span
                            > -->
                        </div>
                        <!-- 文字评价 -->
                        <div
                            v-if="text_voice == 0 && text_show"
                            class="text-voice-evaluate-content text-voice-evaluate-content-after"
                        >
                            <div class="text">{{ sContent }}</div>
                        </div>
                        <!-- 语音评价 -->
                        <div
                            v-if="text_voice == 1 && voice_show"
                            class="text-voice-evaluate-content"
                        >
                            <!-- 点击录制语音 -->
                            <!-- <div v-if="!BshowToast" class="recording-voice">
                <div @click="clickRecord" class="recording-voice-btn"></div>
                <span>{{
                    status == "start" ? "点击结束录制" : "点击录制评价语音"
                }}</span>
                </div> -->
                            <!-- 点击试听录制语音 -->
                            <div @click="audioClick" class="play-voice">
                                <div class="play-voice-fish"></div>
                                <span class="">{{ voice_time }}s</span>
                                <!-- <span @click="delete_voicl" class="delete">删除</span> -->
                                <!-- <span class="wire">|</span>
                <div class="voice-icon"></div> -->
                                <div class="play-voice-text">
                                    点击试听录制语音
                                </div>
                                <audio
                                    ref="audioRef"
                                    class="audio-ref"
                                    :src="sAudioUrl"
                                />
                            </div>
                        </div>
                    </div>
                    <!-- 图片上传 -->
                    <div class="image-uploading" v-if="arrLocalBase64.length">
                        <div class="image-uploading-title">
                            <span> 图片/视频上传</span>
                            <div class="photo-img" @click="openPhoto">
                                <span>照片示例</span>
                                <img src="@/assets/images/198.png" alt="">
                            </div>
                        </div>
                        <!-- 图片上传 -->
                        <!------------------开始------------------- 图片视频上传 -----------------------开始--------------------->
                        <div
                            class="addContent2"
                            style="margin-top: 0; padding: 0"
                        >
                            <div class="imgbox">
                                <div
                                    class="img-div"
                                    v-for="(item, index) in arrLocalBase64"
                                    :key="index"
                                >
                                    <!-- 删除视频图片按钮 -->
                                    <!-- <img
                    @click="deleImg(index)"
                    class="delete-image"
                    src="@/assets/images/image-delete.png"
                    /> -->
                                    <img
                                        v-if="item.type == 'image'"
                                        @click="
                                            handleImagePreview(
                                                arrLocalBase64,
                                                index
                                            )
                                        "
                                        :src="item.pic"
                                        alt=""
                                        class="img"
                                    />
                                    <video
                                        v-else
                                        @click="playVideo(item.pic)"
                                        :src="item.pic"
                                        alt=""
                                        :poster="
                                            item.pic +
                                            '?x-oss-process=video/snapshot,t_1000,m_fast'
                                        "
                                        class="img"
                                    ></video>
                                    <div
                                        @click="playVideo(item.pic)"
                                        v-if="item.type != 'image'"
                                        class="video-play"
                                    ></div>
                                </div>
                                <!-- 上传图片视频按钮 -->
                                <!-- <div class="img-div">
                    <img
                    @click="choiceImg"
                    src="@/assets/images/user/house/add_image_video.png"
                    alt=""
                    class="img"
                    />
                </div>
                <input
                    style="display: none"
                    @change="imageToBase64"
                    ref="filElem"
                    type="file"
                    id="input"
                />
                <div id="in-box" style="display: none"></div> -->
                            </div>
                        </div>
                        <!------------------结束------------------- 图片视频上传 -----------------------结束--------------------->
                    </div>
                </div>
            </template>
            <!-- 追加评价页面  -->
            <template v-if="additional_evaluation == 2">
                <template v-if="showInfo == 2">
                    <share :isFixed="isFixed" />
                </template>
                <template v-else>
                    <!-- 底部提交按钮 -->
                    <div class="submit">
                        <div class="submit-checkout">
                            <van-checkbox
                                icon-size="15px"
                                checked-color="#ffffff"
                                shape="square"
                                v-model="anonymous_show"
                            >
                                同意匿名展示评价/工地现场图片</van-checkbox
                            >
                            <van-icon
                                @click="notice = true"
                                class="icon"
                                size="15"
                                color="#CCCCCC"
                                name="question"
                            />
                        </div>
                        <div @click="reSubmit" class="submit-btn additional">
                            确认追加
                        </div>
                    </div>
                </template>
                <!-- 主体部分 -->
                <div class="main-content pd7">
                    <div class="main-content-explain">
                        非常感谢您对A.O.史密斯的信任和支持，您的冷暖风水系统产品已经全部安装并调试完毕，现场验收合格还请您验收。
                    </div>
                    <div class="check-agree">
                        <van-checkbox
                            style="margin-left: auto"
                            checked-color="#355D4B"
                            shape="square"
                            v-model="trues"
                            disabled
                            >我已阅读并确认全部验收合格</van-checkbox
                        >
                    </div>
                    <div class="underline"></div>
                    <div class="main-content-hint">
                        <div class="hing-img"></div>
                        <span
                            >您的评价/工地现场图片能帮助其他人更真实的了解产品~</span
                        >
                    </div>
                    <div class="publish">发表追评</div>
                    <!-- 评价 -->
                    <div class="text-voice-evaluate" style="margin-top: 0">
                        <div class="text-voice-evaluate-title">
                            <span style="color: #333333">文字评价</span>
                            <!-- <span
                @click="text_voice = 1"
                :style="text_voice == 1 ? 'color:#333333' : ''"
                >语音评价</span
                > -->
                        </div>
                        <!-- 文字评价 -->
                        <div class="text-voice-evaluate-content text-voice-evaluate-content-before">
                            <textarea
                                maxlength="-1"
                                class="text no-resize"
                                :placeholder="nProjectType==2?'您可以从空气温度、湿度、新鲜度、洁净度、运行声音五个维度，或不同房间、不同家庭成员使用体验进行评价，也可对系统节能性、操控性、售后服务等方面进行评价...':'您可以从空调、采暖、新风（如已购）使用体验，系统节能性、操控性，售后服务等方面进行评价...'"
                                v-model.trim="addContent2"
                            ></textarea>
                        </div>
                        <!-- 语音评价 -->
                        <!-- <div v-else class="text-voice-evaluate-content">
            <div v-if="!BshowToast" class="recording-voice">
                <div @click="clickRecord" class="recording-voice-btn"></div>
                <span>{{
                    status == "start" ? "点击结束录制" : "点击录制评价语音"
                }}</span>
                </div> -->
                        <!-- 点击试听录制语音 -->
                        <!-- <div v-else @click="Audition" class="play-voice">
                <div class="play-voice-fish"></div>
                <span class="">{{ voice_time }}s</span>
                <span @click="delete_voicl" class="delete">删除</span>
                <span class="wire">|</span>
                <div class="voice-icon"></div>
                <div class="play-voice-text">点击试听录制语音</div>
                <audio ref="audioRef" class="audio-ref" :src="sAudioUrl" />
                </div> -->
                        <!-- </div> -->
                    </div>
                    <!-- 图片上传 -->
                    <div class="image-uploading">
                        <div class="image-uploading-title">
                            <span> 图片/视频上传</span>
<!--                            <div class="photo-img" @click="openPhoto">-->
<!--                                <span>照片示例</span>-->
<!--                                <img src="@/assets/images/198.png" alt="">-->
<!--                            </div>-->
                        </div>
                        <!-- 图片上传 -->
                        <!------------------开始------------------- 图片视频上传 -----------------------开始--------------------->
                        <div class="image-uploading">
                            <div class="addContent2" style="padding: 0">
                                <div class="imgbox">
                                    <div
                                        class="img-div"
                                        v-for="(item, index) in arrMedia"
                                        :key="index"
                                    >
                                        <!-- 删除视频图片按钮 -->
                                        <img
                                            @click="deleImg(index)"
                                            class="delete-image"
                                            src="@/assets/images/image-delete.png"
                                        />
                                        <img
                                            v-if="item.type == 'image'"
                                            @click="
                                                handleImagePreview(
                                                    arrMedia,
                                                    index
                                                )
                                            "
                                            :src="item.url"
                                            alt=""
                                            class="img"
                                        />
                                        <video
                                            v-else
                                            @click="playVideo(item.url)"
                                            :src="item.url"
                                            alt=""
                                            :poster="
                                                item.url +
                                                '?x-oss-process=video/snapshot,t_1000,m_fast'
                                            "
                                            class="img"
                                        ></video>
                                        <div
                                            @click="playVideo(item.url)"
                                            v-if="item.type != 'image'"
                                            class="video-play"
                                        ></div>
                                    </div>
                                    <!-- 上传图片视频按钮 -->
                                    <div class="img-div">
                                        <img
                                            @click="choiceImg"
                                            src="@/assets/images/user/house/add_image_video.png"
                                            alt=""
                                            class="img"
                                        />
                                    </div>
                                    <input
                                        style="display: none"
                                        @change="imageToBase64"
                                        ref="filElem"
                                        type="file"
                                        accept="image/*,video/*"
                                        id="input"
                                    />
                                    <div
                                        id="in-box"
                                        style="display: none"
                                    ></div>
                                </div>
                            </div>
                        </div>
                        <!------------------结束------------------- 图片视频上传 -----------------------结束--------------------->
                    </div>
                </div>
            </template>
            <!-- 完成首评追评  -->
            <template v-if="additional_evaluation == 3">
                <template v-if="showInfo == 2">
                    <share :isFixed="isFixed" />
                </template>
                <!-- 主体部分 -->
                <div class="main-content bottom108">
                    <div class="main-content-explain">
                        非常感谢您对A.O.史密斯的信任和支持，您的冷暖风水系统产品已经全部安装并调试完毕，现场验收合格还请您验收。
                    </div>
                    <div class="check-agree">
                        <van-checkbox
                            style="margin-left: auto"
                            checked-color="#355D4B"
                            shape="square"
                            v-model="trues"
                            disabled
                            >我已阅读并确认全部验收合格</van-checkbox
                        >
                    </div>
                    <div class="underline"></div>
                    <div class="main-content-hint">
                        <div class="hing-img"></div>
                        <span
                            >您的评价/工地现场图片能帮助其他人更真实的了解产品~</span
                        >
                    </div>
                    <!-- 五星评价-->
                    <template v-for="(item, index) of evaluateTag">
                        <div
                            :key="index"
                            class="main-content-instructions mt48"
                        >
                            <!-- 说明 -->
                            <div class="declare">
                                {{ index + 1 }}.{{ item.title }}
                            </div>
                            <!-- 五星 -->
                            <div class="five-stars">
                                <van-rate
                                    color="#FCBF82"
                                    readonly
                                    size="0.58rem"
                                    @change="rates(index, item.id)"
                                    void-icon="star"
                                    void-color="#DDDDDD"
                                    v-model="evaluateStar[index]"
                                />
                                <span>{{ evaluateStar[index] }}分</span>
                            </div>
                            <!-- 标签 -->
                            <div v-if="evaluateStar[index]" class="label">
                                <template
                                    v-for="(items, indexs) of evaluateTag[index]
                                        .tags[evaluateStar[index]]"
                                >
                                    <span
                                        v-if="items.style"
                                        :style="
                                            items.style
                                                ? 'background:#EAEEED;color:#355D4B;font-weight:bold'
                                                : ''
                                        "
                                        :key="indexs"
                                    >
                                        {{ items.title }}
                                    </span>
                                </template>
                            </div>
                        </div>
                    </template>
                    <!-- 评价 -->
                    <div
                        class="text-voice-evaluate"
                        v-if="text_show || voice_show"
                    >
                        <div class="text-voice-evaluate-title">
                            <span
                                v-if="text_show"
                                @click="text_voice = 0"
                                :style="text_voice == 0 ? 'color:#333333' : ''"
                                >文字评价</span
                            >
                            <!-- <span
                                v-if="voice_show"
                                @click="text_voice = 1"
                                :style="text_voice == 1 ? 'color:#333333' : ''"
                                >语音评价</span
                            > -->
                        </div>
                        <!-- 文字评价 -->
                        <div
                            v-if="text_voice == 0 && text_show"
                            class="text-voice-evaluate-content text-voice-evaluate-content-after"
                        >
                            <div class="text">{{ sContent }}</div>
                        </div>
                        <!-- 语音评价 -->
                        <div
                            v-if="text_voice == 1 && voice_show"
                            class="text-voice-evaluate-content"
                        >
                            <!-- 点击录制语音 -->
                            <!-- <div v-if="!BshowToast" class="recording-voice">
                <div @click="clickRecord" class="recording-voice-btn"></div>
                <span>{{
                    status == "start" ? "点击结束录制" : "点击录制评价语音"
                }}</span>
                </div> -->
                            <!-- 点击试听录制语音 -->
                            <div @click="audioClick" class="play-voice">
                                <div class="play-voice-fish"></div>
                                <span class="">{{ voice_time }}s</span>
                                <!-- <span @click="delete_voicl" class="delete">删除</span> -->
                                <!-- <span class="wire">|</span>
                <div class="voice-icon"></div> -->
                                <div class="play-voice-text">
                                    点击试听录制语音
                                </div>
                                <audio
                                    ref="audioRef"
                                    class="audio-ref"
                                    :src="sAudioUrl"
                                />
                            </div>
                        </div>
                    </div>
                    <!-- 图片上传 -->
                    <div class="h64" v-if="!arrLocalBase64.length"></div>
                    <div class="image-uploading" v-if="arrLocalBase64.length">
                        <div
                            class="image-uploading-title"
                            style="margin-left: 0"
                        >
                            <span> 图片/视频上传</span>
                            <div class="photo-img" @click="openPhoto">
                                <span>照片示例</span>
                                <img src="@/assets/images/198.png" alt="">
                            </div>
                        </div>
                        <div class="addContent2" style="padding: 0">
                            <div class="imgbox">
                                <div
                                    class="img-div"
                                    v-for="(item, index) in arrLocalBase64"
                                    :key="index"
                                >
                                    <!-- 删除视频图片按钮 -->
                                    <img
                                        style="display: none"
                                        @click="deleImg(index)"
                                        class="delete-image"
                                        src="@/assets/images/image-delete.png"
                                    />
                                    <img
                                        v-if="item.type == 'image'"
                                        @click="
                                            handleImagePreview(
                                                arrLocalBase64,
                                                index
                                            )
                                        "
                                        :src="item.pic"
                                        alt=""
                                        class="img"
                                    />
                                    <video
                                        v-else
                                        @click="playVideo(item.pic)"
                                        :src="item.pic"
                                        alt=""
                                        :poster="
                                            item.pic +
                                            '?x-oss-process=video/snapshot,t_1000,m_fast'
                                        "
                                        class="img"
                                    ></video>
                                    <div
                                        @click="playVideo(item.pic)"
                                        v-if="item.type != 'image'"
                                        class="video-play"
                                    ></div>
                                </div>
                                <!-- 上传图片视频按钮 -->
                                <!-- <div class="img-div">
                    <img
                    @click="choiceImg"
                    src="@/assets/images/user/house/add_image_video.png"
                    alt=""
                    class="img"
                    />
                </div>
                <input
                    style="display: none"
                    @change="imageToBase64"
                    ref="filElem"
                    type="file"
                    id="input"
                />
                <div id="in-box" style="display: none"></div> -->
                            </div>
                        </div>
                    </div>
                    <div class="add_evaluation">追加评价：</div>
                    <div class="add_evaluation_content">
                        {{ addContentAdd }}
                    </div>
                    <!-- 图片上传 -->
                    <!------------------开始------------------- 图片视频上传 -----------------------开始--------------------->
                    <div class="image-uploading">
                        <div class="addContent2" style="padding: 0">
                            <div class="imgbox">
                                <div
                                    class="img-div"
                                    v-for="(item, index) in arrLocalBase64Add"
                                    :key="index"
                                >
                                    <!-- 删除视频图片按钮 -->
                                    <img
                                        style="display: none"
                                        @click="deleImg(index)"
                                        class="delete-image"
                                        src="@/assets/images/image-delete.png"
                                    />
                                    <img
                                        v-if="item.type == 'image'"
                                        @click="
                                            handleImagePreview(
                                                arrLocalBase64Add,
                                                index
                                            )
                                        "
                                        :src="item.pic"
                                        alt=""
                                        class="img"
                                    />
                                    <video
                                        v-else
                                        @click="playVideo(item.pic)"
                                        :src="item.pic"
                                        alt=""
                                        :poster="
                                            item.pic +
                                            '?x-oss-process=video/snapshot,t_1000,m_fast'
                                        "
                                        class="img"
                                    ></video>
                                    <div
                                        @click="playVideo(item.pic)"
                                        v-if="item.type != 'image'"
                                        class="video-play"
                                    ></div>
                                </div>
                                <!-- 上传图片视频按钮 -->
                                <!-- <div class="img-div">
                    <img
                    v-if="false"
                    @click="choiceImg"
                    src="@/assets/images/user/house/add_image_video.png"
                    alt=""
                    class="img"
                    />
                </div>
                <input
                    v-if="false"
                    @change="imageToBase64"
                    ref="filElem"
                    type="file"
                    id="input"
                />
                <div id="in-box" style="display: none"></div> -->
                            </div>
                        </div>
                    </div>
                    <!------------------结束------------------- 图片视频上传 -----------------------结束--------------------->
                </div>
            </template>
            <!-- 协议弹窗 -->
            <div v-if="notice" class="notice_fixed">
                <transition name="van-slide-up">
                    <div v-show="notice">
                        <div class="notic_fixed_bottom">
                            <span
                                >当您的冷暖风水系统产品安装并调试完毕后，我们会收集您的【购机类型、设计方案、装机地址、施工照片及视频】用于构建项目案例、形成口碑地图等。当您留言或进行评价时，我们会收集您的【微信昵称、头像、评价内容（包含照片、视频、语音）】用于展示商品评价。我们会对您的头像、昵称、购机信息、装机地址、施工现场匿名化或脱敏后才对外展示和公开，您的个人信息经过匿名化与脱敏处理将形成可以使用的流通数据，我们对此数据的存储和使用无需另外征得您的授权同意。如您同意并接受，请进行勾选同意。</span
                            >
                            <div @click="notice = false">关闭</div>
                        </div>
                    </div>
                </transition>
            </div>
            <!-- 查看视频 -->
            <van-popup
                class="pop"
                close-icon="close"
                v-model="isVideoShow"
                closeable
                @close="closeVideo"
            >
                <div class="wrapper" v-if="isVideoShow">
                    <!-- <div class="video-qp"> -->
                        <video
                            :style="{ height: '100%', width: '100%' }"
                            :src="sVideoPath"
                            controls
                            webkit-playsinline="true"
                            playsinline="true"
                            x5-video-player-fullscreen="true"
                            x5-video-player-type="h5"
                        ></video>
                        <!-- <video
                            id="player-container-id"
                            preload="auto"
                            playsinline
                            webkit-playsinline
                        ></video> -->
                        <!-- <video
                            @click="showVideo()"
                            id="myVideo01"
                            class="video-js"
                            :poster="
                                sVideoPath +
                                '?x-oss-process=video/snapshot,t_1,f_jpg,w_200,h_200,m_fast'
                            "
                        >
                            <source type="video/mp4" :src="sVideoPath" />
                            <source type="video/webm" :src="sVideoPath" />
                            <source type="video/ogg" :src="sVideoPath" />
                        </video> -->
                    <!-- </div> -->
                </div>
            </van-popup>
        </div>
        <shematic :type="nProjectType" v-if="isShowSchematic" @closeSchematic="closeSchematic"></shematic>
    </div>
</template>

<script>
import shematic from '../components/schematic'
// import { getWxSingleConfig } from "@/js/wx.js";
import { ImagePreview } from "vant";
import {
    getList,
    tagList,
    reSubmit,
    discussAdd,
    ossconfig,
    sendSeriveId,
    projectType
} from "@/js/house/appindex.js";
import share from "../../../member/v2/components/share.vue";
let OSS = require("ali-oss");
let matched = [];
export default {
    components: {
        share,
        shematic
    },
    data() {
        return {
            nProjectType:1,
            isShowSchematic:false,
            options: {
                hlsUrl: "https://lib.baomitu.com/hls.js/0.8.9/hls.min.js", // 0.0.5增加
                width: "100%",
                height: "100%",
                m3u8: "http://1251203672.vod2.myqcloud.com/43464984vodtransgzp1251203672/957853b25285890790261970276/v.f230.m3u8",
            },
            bBack: matched.length,
            isFixed: true,
            isAgree: false, //我已阅读并确认全部验收合格
            upLoadFiles: [], //传给后台的数据
            isVideoShow: false, //是否显显示视频播放控件
            startTime: "", // 录音开始时间
            endTime: "", //录音结束时间
            voice_time: "", //录音秒数 如45s
            status: "close", //开始录音
            localId: "", //录音id
            AuditionStatus: "试听录音", //控制试听的播放和暂停
            BshowToast: false, //是否录音
            // sProjectUuid: "b13802aa-691e-ac6d-0000-0633f674b76a", //请求参数
            company_id: this.$route.query.company_id, //公司id
            contract_id: this.$route.query.contract_id, //合同id
            topic_id: this.$route.query.topic_id, //项目id
            sProjectUuid: this.$route.query.project_uuid, //请求参数
            remove: this.$route.query.remove, //请求参数
            content: "", //评价
            addContent: "", //追加评价
            sContent: "", //文字评价
            arrMedia: [], //本地展示的数据 图片 视频
            addarrMedia: [], //追加展示的数据 图片 视频
            oss: {}, //oss相关配置
            additional_evaluation: 4, //未评价0 已经评价1 追加评价2 完成首评追评3
            notice: false, //须知
            anonymous_show: true, //同意匿名展示
            label_evaluate: {
                evaluate_one: 0,
                evaluate_two: 0,
                evaluate_three: 0,
            }, //评价星星
            text_voice: 0, //文字评价0，语音评价1
            evaluate_text: "", //文字评价value
            sAudioUrl: "", //语音评价value
            transcribe: 0, //未录制 0 已录制1
            sVoiceUrl: "",
            sVideoPath: "", //弹出视频的src
            evaluateTag: {}, //评价标签
            evaluateStar: [], //评价星星
            evaluateId: {}, //评价id
            tags: [], //评价 标签加星级
            arrLocalBase64: [],
            arrLocalBase64Add: [],
            text_show: true,
            voice_show: true,
            addContent2: "",
            discuss_id: null,
            addContentAdd: "",
            trues: true,
            showInfo: "",
            player: null,
        };
    },
    created() {
        // getWxSingleConfig().then(() => {
        this.showInfo = this.$route.query.sampleroom;
        console.log(this.showInfo);
        // 清除数据
        // net.delete({
        //   user_id: 682,
        //   project_uuid: this.sProjectUuid,
        // });
        this.$store.commit("loadSkeleton", { bool: true });
        this.$store.dispatch("banner/getAppBanner", {
            source: "h5",
            adment_id: 12,
            user_id: this.$storage.getStorage("app_user_id"),
        });
        // getWxSingleConfig();
        this.getData().then(() => {
            projectType({project_uuid:this.sProjectUuid}).then(res=>{
                this.nProjectType = res.data.data.result.type=='智慧五恒'?2:1
            })
            getList({
                app: 1,
                project_uuid: this.sProjectUuid,
                type: 1,
                user_id: this.$storage.getStorage("app_user_id"),
                mobile: this.$route.query.appmob || '',
            }).then((res) => {
                this.$store.commit("loadSkeleton", {
                    bool: false,
                });
                this.addContentAdd = res.data.data.result.content2;
                this.discuss_id = res.data.data.result.id;
                this.anonymous_show =
                    res.data.data.result.is_anonymous == 0 ? false : true;
                this.text_show =
                    res.data.data.result.content == null ||
                    res.data.data.result.content == ""
                        ? false
                        : true;
                this.voice_show =
                    res.data.data.result.voice == "" ? false : true;
                if (res.data.data.result.length == 0) {
                    this.additional_evaluation = 0;
                    this.anonymous_show = true;
                } else if (res.data.data.result.is_completed == 1) {
                    this.additional_evaluation = 1;
                    this.evaluateId = [];
                } else if (res.data.data.result.is_completed == 2) {
                    this.additional_evaluation = 3;
                }
                let puge = res.data.data.result.tags
                    ? JSON.parse(res.data.data.result.tags)
                    : [];
                if (puge.length) {
                    for (let i = 0; i < puge.length; i++) {
                        this.evaluateStar[i] = puge[i].score;
                        this.evaluateId[i] = puge[i].tags;
                    }
                }
                let aret = [];
                if (this.evaluateStar.length) {
                    console.log(this.evaluateStar, "this.evaluateStar.length");
                    for (let i = 0; i < this.evaluateStar.length; i++) {
                        aret.push(
                            this.evaluateTag[i].tags[this.evaluateStar[i]]
                        );
                    }
                }
                console.log(aret, "aret");
                if (puge.length > 0) {
                    for (let i = 0; i < aret.length; i++) {
                        aret[i].forEach((v) => {
                            this.evaluateId[i].forEach((val) => {
                                if (v.id == val) {
                                    v.style = true;
                                }
                            });
                        });
                    }
                }

                this.sAudioUrl = res.data.data.result.voice;
                this.voice_time = res.data.data.result.voice_time;
                this.sContent = res.data.data.result.content; //文字评价
                this.arrLocalBase64 = res.data.data.result.pic || []; // 图片，视频列表
                this.arrLocalBase64Add = res.data.data.result.pic_zhui || []; // 图片，视频列表
                // this.addContent = res.data.data.result.completedTo.content; // 追加评价
            });
        });
        // });
    },
    beforeRouteEnter(to, from, next) {
        matched = from.matched;
        next();
    },
    // mounted() {
    //     this.$once("hook:beforeDestroy", () => {
    //         this["myVideo01"].dispose();
    //     });
    // },
    methods: {
        openPhoto(){
            this.isShowSchematic=true
            document.body.style.overflow = 'hidden'
        },
        closeSchematic(){
            document.body.style.overflow = 'auto'
            this.isShowSchematic=false
        },
        closeVideo() {
            // this["myVideo01"].dispose();
        },
        showVideo() {
            let option = {
                //确定播放器是否具有用户可以与之交互的控件。没有控件，启动视频播放的唯一方法是使用autoplay属性或通过Player API。
                controls: true,
                //自动播放属性,muted:静音播放
                autoplay: true,
                //建议浏览器是否应在<video>加载元素后立即开始下载视频数据。
                preload: "auto",
                //设置视频播放器的显示宽度（以像素为单位）
                width: 100,
                //设置视频播放器的显示高度（以像素为单位）
                height: 100,
                //封面图
                x5Playsinline: "true",
                webkitPlaysinline: "true",
                playsinline: true,
            };
            this["myVideo01"] = this.$video("myVideo01", option);
            this["myVideo01"].autoplay(true);
            this["myVideo01"].play();
        },
        goback() {
            this.$router.go(-1);
        },
        goHome() {
            // this.$router.go(-1);
            // console.log(window.location.origin + '/member/v2/index/index');
            window.location.href =
                window.location.origin +
                `/member/v3/index/index?appmob=${this.$storage.getStorage(
                    "app_mob"
                )}`;
        },
        async getData() {
            await tagList({
                type: "jungong",
                user_id: this.$storage.getStorage("app_user_id"),
                app: 1,
            }).then((res) => {
                // let tags = res.data.data.result.tag;
                // res.data.data.result.tag = [];
                // res.data.data.result.process.forEach((v, i) => {
                //   this.evaluateId[i] = [];
                //   res.data.data.result.tag.push(JSON.parse(JSON.stringify(tags)));
                //   this.tags.push({
                //     question_id: v.id,
                //     score: 0,
                //     tags: [],
                //   });
                // });
                // //给每个标签增加属性赋值为false
                res.data.data.result.forEach((o, j) => {
                    for (let index = 1; index <= 5; index++) {
                        o.tags[index].forEach((os, js) => {
                            os.style = false;
                        });
                    }
                });
                // this.evaluateTag = res.data.data.result; //评价标签
                this.evaluateTag = res.data.data.result;
                // 添加五星评分
                this.evaluateTag.forEach((v, i) => {
                    this.evaluateStar.push(0);
                    this.evaluateId[i] = [];

                    this.tags.push({
                        question_id: v.id,
                        score: 0,
                        tags: [],
                    });
                });
            });
        },
        // 处理图片
        // 删除图片
        deleImg(index) {
            this.arrMedia.splice(index, 1);
            this.upLoadFiles.splice(index, 1);
        },
        imageToBase64() {
            var _this = this;
            const inputFile = this.$refs.filElem.files[0];
            this.$refs.filElem.value = null;

            this.inputFile = inputFile;
            if (this.inputFile) {
                let inputFile = this.inputFile;
                // if (
                //     inputFile.type !== "image/jpeg" &&
                //     inputFile.type !== "image/png" &&
                //     inputFile.type !== "image/jpg" &&
                //     inputFile.type !== "video/mp4"
                // ) {
                //     alert("上传图片或者视频！", "warning");
                //     return;
                // }
                if (inputFile.size > 200 * 1024 * 1024) {
                    alert("请上传小于 200M 的图片 ！", "warning");
                    return;
                }
                this.uploadImg(inputFile);
            } else {
                return;
            }
        },
        uploadImg(inputFile) {
            var data = inputFile.name;

            let flieArr = data.split(".");
            let suffix = flieArr[flieArr.length - 1];
            let uploadData = {
                ext: suffix,
                app: 1,
                user_id: this.$storage.getStorage("app_user_id"),
            };
            // 获取oss配置
            ossconfig(uploadData).then((res) => {
                let uploadOss = res.data.data.result;
                let client = new OSS({
                    region: uploadOss.sts.region,
                    bucket: uploadOss.sts.bucket,
                    accessKeyId: uploadOss.sts.access_key_id,
                    accessKeySecret: uploadOss.sts.access_key_secret,
                    endpoint: uploadOss.sts.endpoint_internal,
                    stsToken: uploadOss.sts.security_token,
                    secure: true,
                });

                // oss 上传
                client
                    .multipartUpload(uploadOss.object_name, inputFile)
                    .then((res) => {
                        this.upLoadFiles.push({
                            type: inputFile.type.split("/")[0],
                            url: uploadOss.filename,
                            default: uploadOss.default,
                        });
                        this.arrMedia.push({
                            type: inputFile.type.split("/")[0],
                            url: uploadOss.url,
                            default: uploadOss.default,
                        });
                    });
            });
        },
        choiceImg() {
            if (this.showInfo == 2) return;
            this.$refs.filElem.dispatchEvent(new MouseEvent("click"));
        },
        handleImagePreview(arrList, index) {
            // if (arrList[index].type === "image") {
            let arrImage = [];
            //let data = JSON.parse(JSON.stringify(arrList))
            arrList.forEach((item) => {
                //过滤video
                // if (item.type === "image") {
                if (item.pic) {
                    arrImage.push(item.pic);
                } else if (item.url) {
                    arrImage.push(item.url);
                }
                // }
            });
            let str = "";
            if (arrList[index].pic) {
                str = arrList[index].pic;
            } else if (arrList[index].url) {
                str = arrList[index].url;
            }
            //arrImage.splice(index, 1)
            //arrImage.splice(0, 0, str)
            ImagePreview(arrImage, index);
            // }
        },
        playVideo(url) {
            // console.log("323");
            this.isVideoShow = true;
            this.sVideoPath = url;
            this.$nextTick(() => {
                var player = TCPlayer("player-container-id", {}); // player-container-id 为播放器容器 ID，必须与 html 中一致
                player.src(url); // url 播放地址
            });
        },
        // 点击录音
        clickRecord() {
            if (this.showInfo == 2) return;
            if (this.status === "close") {
                wx.startRecord({
                    success: () => {
                        this.status = "start";
                        //alert("录音中");
                        this.startTime = new Date().getTime();
                        // setTimeout(() => {
                        //   this.clickRecord();
                        //   console.log("超出最长录制时间");
                        // }, 60000);
                        // setTimeout(() => {
                        //   this.BshowToast = true;
                        //   console.log('录音结束');
                        // }, 6000);
                    },
                    cancel: () => {
                        //alert("不允许");
                    },
                    complete: (e) => {
                        console.log(e);
                    },
                    fail: (res) => {
                        alert("您未开启录音权限,请重试");
                    },
                });
            } else if (this.status === "start") {
                this.status = "close";
                this.endTime = new Date().getTime();
                const diffTime = this.endTime - this.startTime;
                this.voice_time = (diffTime / 1000).toFixed(1);

                wx.stopRecord({
                    success: (res) => {
                        this.localId = res.localId;
                        this.BshowToast = true;
                    },
                    fail: (res) => {
                        alert("关闭录音失败，清重试");
                    },
                });
            }
        },
        // 判断用户目前是否在试听录音
        stopListen() {
            if (this.AuditionStatus == "正在试听") {
                wx.stopVoice({
                    localId: this.localId, // 需要停止的音频的本地ID，由stopRecord接口获得
                });
            }
            this.BshowToast = false;
            this.AuditionStatus = "试听录音";
        },
        //  删除录音
        delete_voicl() {
            wx.stopVoice({
                localId: this.localId, // 需要停止的音频的本地ID，由 stopRecord 接口获得
            });
            this.localId = "";
            this.BshowToast = false;
        },
        // 点击试听触发的函数
        Audition() {
            if (this.AuditionStatus != "正在试听") {
                console.log("试听录音");
                this.AuditionStatus = "正在试听";
                wx.playVoice({
                    localId: this.localId, // 需要播放的音频的本地ID，由stopRecord接口获得
                });
            } else {
                console.log("暂停录音");
                this.AuditionStatus = "已暂停";
                wx.pauseVoice({
                    localId: this.localId, // 需要暂停的音频的本地ID，由stopRecord接口获得
                });
            }
        },
        // 上传已录制语音
        updateVoice() {
            wx.uploadVoice({
                localId: this.localId, // 需要上传的音频的本地ID，由stopRecord接口获得
                isShowProgressTips: 1, // 默认为1，显示进度提示
                //可以在success回调里把id传给自己的服务器后台，然后走微信服务器里下载
                success: (result) => {
                    // serverId = res.serverId; // 返回音频的服务器端ID
                    // alert('上传成功')
                    // alert(result.serverId);

                    //把录音在微信服务器上的id（res.serverId）发送到自己的服务器供下载。
                    // Sendserive_id({service_id:result.serverId}).then(result2 => {console.log(result2,'这个是结果2');})
                    // this.$store.dispatch("finish/SendId", {
                    //     service_id: result.serverId,
                    // });

                    sendSeriveId({
                        service_id: result.serverId,
                        user_id: this.$storage.getStorage("app_user_id"),
                    }).then((res) => {
                        // console.log(result.serverId);
                        let result = res.result;
                        this.sVoiceUrl = result.local_file;
                        this.discussAdd(this.sVoiceUrl);
                    });
                },
            });
        },
        // 点击播放语音评价
        audioClick() {
            const audio = this.$refs.audioRef;
            audio.paused ? audio.play() : audio.pause();
            // if (audio.paused) {
            //     // console.log("语音动态关");
            //     this.isAudio = false
            // } else {
            //     // console.log("语音动态开");
            //     this.isAudio = true
            // }
        },
        // 添加评价
        submit() {
            if (!this.isAgree) {
                this.$toast("请勾选我已阅读并确认全部验收合格");
                return;
            }
            if (this.evaluateTag.length) {
                if (!this.evaluateStar[0]) {
                    this.$toast("请进行星级评价");
                    return;
                }
            }
            if(!this.sContent){
                this.$toast("请输入评价文字!");
                return;
            }
            if(this.upLoadFiles.length<=0){
                this.$toast("至少上传一张图片!");
                return;
            }
            let pubg = this.evaluateStar.some((v) => {
                return v != 0;
            });
            if (pubg) {
                let pubgs = [];
                for (let i = 0; i < this.evaluateStar.length; i++) {
                    pubgs.push(this.evaluateId[i].length);
                }
                let pb = pubgs.some((v) => {
                    return v == 0;
                });
                if (pb) {
                    this.$toast("评价标签有未选项");
                } else {
                    for (let i = 0; i < this.tags.length; i++) {
                        this.tags[i].score = this.evaluateStar[i];
                        this.tags[i].tags = this.evaluateId[i];
                    }
                    // if (this.text_voice == 1) {
                    // 上传语音录入的方法
                    if (this.localId) {
                        this.updateVoice();
                    } else {
                        this.discussAdd("");
                    }
                    // } else {
                    //     this.discussAdd("");
                    // }
                }
            } else {
                // if (this.text_voice == 1) {
                // 上传语音录入的方法
                if (this.localId) {
                    this.updateVoice();
                } else {
                    this.discussAdd("");
                }
                // } else {
                //     this.discussAdd("");
                // }
            }
        },
        // 添加追加评价
        reSubmit() {
            // 判断是否输入文字和图片
            if(!this.addContent2){
                this.$toast('请输入文字评价!')
                return
            }
            if(this.upLoadFiles.length<=0){
                this.$toast('追评最少上传一张图片!')
                return
            }
            //if (this.topic_id && this.company_id && this.contract_id) {
            let data = {
                type: 2,
                app: 1,
                // voice_time: this.voice_time,
                zhui_content: this.addContent2,
                pic: JSON.stringify(this.upLoadFiles), //oss返回的图片或视频链接
                contract_id: this.contract_id,
                company_id: this.company_id ? this.company_id : 1,
                topic_id: this.topic_id,
                project_uuid: this.sProjectUuid,
                is_anonymous: this.anonymous_show ? 1 : 0,
                share_user_id: this.$route.query.sharePersonId || 0,
                is_app:1,
                is_zhui_app:1,
                discuss_id: this.discuss_id, //追评 评价主表id
                user_id: this.$storage.getStorage("app_user_id"),
            };
            this.$store.commit("loadSwitch", true);

            reSubmit(data).then((res) => {
                this.$toast("添加成功");
                // this.$router.go(-1);
                this.$router.go(0);
                setTimeout(()=>{
                    this.$store.commit("loadSwitch", false);
                },500)
                // this.goHome();
            });
        },
        discussAdd(val) {
            let data = {
                type: 1,
                app: 1,
                content: this.sContent, //文字评价
                tags: JSON.stringify(this.tags),
                voice: val, //语音评价
                voice_time: this.voice_time,
                pic: JSON.stringify(this.upLoadFiles), //oss返回的图片或视频链接
                contract_id: this.contract_id,
                topic_id: this.topic_id,
                is_anonymous: this.anonymous_show ? 1 : 0,
                project_uuid: this.sProjectUuid,
                user_id: this.$storage.getStorage("app_user_id"),
                share_user_id:this.$route.query.sharePersonId || 0,
                is_app:1,
                // discuss_id: '', //追评 评价主表id
                // zhui_content: '' // 追评  内容
                // project_uuid: this.sProjectUuid,
                // company_id: this.company_id ? this.company_id : 1,
            };
            this.$store.commit("loadSwitch", true);

            discussAdd(data).then((res) => {
                this.$toast("评论完成");
                this.$router.go(0);
                setTimeout(()=>{
                    this.$store.commit("loadSwitch", false);
                },500)
                // this.$router.push({
                //     path: "/member/v3/process/index",
                //     query: {
                //         project_uuid: this.sProjectUuid,
                //     },
                // });
            });
        },
        selectTag(index, id) {
            if (this.evaluateId[index].length) {
                let pubg = this.evaluateId[index].some((v, i) => {
                    return id == v;
                });
                if (pubg) {
                    for (let j = 1; j <= 5; j++) {
                        this.evaluateTag[index].tags[j].forEach((v) => {
                            if (v.id == id) {
                                v.style = false;
                            }
                        });
                    }
                    this.evaluateId[index] = this.evaluateId[index].filter(
                        (v, i) => {
                            return v != id;
                        }
                    );
                } else {
                    this.evaluateId[index].push(id);
                    for (let j = 1; j <= 5; j++) {
                        this.evaluateTag[index].tags[j].forEach((v) => {
                            if (v.id == id) {
                                v.style = true;
                            }
                        });
                    }
                }
            } else {
                this.evaluateId[index].push(id);
                for (let j = 1; j <= 5; j++) {
                    this.evaluateTag[index].tags[j].forEach((v) => {
                        if (v.id == id) {
                            v.style = true;
                        }
                    });
                }
            }
        },
        // 选择一组，清除上一组
        rates(index, id) {
            for (let i = 1; i <= 5; i++) {
                this.evaluateTag[index].tags[i].forEach((v) => {
                    v.style = false;
                });
            }
            this.evaluateId[index] = [];
        },
    },
};
</script>
<style>
.van-popup__close-icon--top-right{
    top: 58px !important;
}
</style>
<style lang="scss" scoped>
video::-webkit-media-controls-fullscreen-button {
    display: none;
}
::v-deep .video-js .vjs-fullscreen-control {
    display: none;
}
.video-js {
    width: 100%;
    height: 100%;
}
.h64 {
    width: 100%;
    height: 64px;
}

.hei180 {
    height: 180px !important;
}

.video-play {
    position: absolute;
    top: 0;
    left: 0;
    width: 160px;
    height: 160px;
    background: rgba(0, 0, 0, 0.4);
    border-radius: 24px;
    z-index: 10;

    &::before {
        content: "";
        position: absolute;
        top: 65px;
        left: 65px;
        border-top: 20px solid transparent;
        border-left: 40px solid #fff;
        border-bottom: 20px solid transparent;
        z-index: 11;
    }
}

.delete-image {
    width: 35px;
    height: 35px;
    position: absolute;
    top: 0;
    right: 0;
    z-index: 70;
}

.pop {
    background-color: transparent;
}

.wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100vw;
    height: 100vh;
    .video-qp {
        width: 80%;
        height: 60%;
        border: 1px solid #ffffff;
    }
}

.addContent2 {
    width: 100%;
    margin-top: 60px;
    padding: 0 32px;

    div:nth-child(1) {
        font-size: 28px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #444444;
        line-height: 40px;
        margin-bottom: 24px;
    }

    .input {
        width: 100% !important;
        padding: 24px;
        background: #f7f7f7;
        border-radius: 12px;
        width: 232px;
        font-size: 28px;
        font-weight: 400;
        color: #858585;
        line-height: 40px;
        margin-bottom: 28px;
    }

    .imgbox {
        display: flex;
        flex-wrap: wrap;
        justify-content: flex-start;
        margin-bottom: 40px;

        .img {
            width: 160px;
            height: 160px;
            background: #eeeeee;
            border-radius: 24px;
            // margin: 10px;
            object-fit: cover;
        }

        .img-div {
            width: 160px;
            height: 160px;
            position: relative;
            margin: 0 32px 32px 0;
        }
    }

    .addContentBtn {
        width: 186px;
        height: 68px;
        margin: 0 auto;
        // padding: 16px 44px;
        text-align: center;
        line-height: 69px;
        border-radius: 43px;
        border: 2px solid #898989;
        font-size: 24px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #444444;
        margin-bottom: 74px;
    }
}

.audio-ref {
    position: absolute;
    z-index: -1;
}

.mt0 {
    margin: 0 auto !important;
}

.additional {
    margin: 20px auto 0 !important;
    background: #f5f7f6 !important;
    color: #355d4b !important;
    border: 1px solid #355d4b;
}

.publish {
    font-size: 28px;
    color: #333333;
    margin: 32px 0 64px 48px;
    font-weight: 500;
}

.add_evaluation {
    font-size: 28px;
    color: #333333;
    margin: 0 0 48px 32px;
    font-weight: 500;
}

.add_evaluation_content {
    width: 654px;
    width: calc(654px);
    height: auto;
    font-size: 28px;
    color: #333333;
    margin: 0 auto;
}

.bottom108 {
    padding: 64px 0 calc(env(safe-area-inset-bottom) + 108px) 0 !important;
}

.margin64 {
    margin: 64px auto 0 auto !important;
}

.main {
    padding-left: env(safe-area-inset-left);
    padding-right: env(safe-area-inset-right);
    padding-bottom: env(safe-area-inset-bottom);
    .back_warp {
        position: relative;
        background: #f9f9f9;
        padding-top: 16px;
        height: calc(100vh - env(safe-area-inset-bottom) - 180px);
        overflow-x: hidden;
        overflow-y: scroll;
    }

    .header_back {
        background: #fff;
        padding-top: 60px;
        box-sizing: border-box;
        height: 180px;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 30px;
        position: relative;

        .back_icon {
            position: absolute;
            left: 50px;
            width: 100px;
            height: 100px;
            z-index: 2;
            display: flex;
            align-items: center;
            span {
                display: block;
                width: 18px;
                height: 18px;
                border: 3px solid #000;
                border-right: 0;
                border-bottom: 0;
                transform: rotate(-45deg);
            }
        }
    }

    .main-home {
        position: fixed;
        right: 4px;
        bottom: 388px;
        width: 112px;
        height: 112px;
        z-index: 998;

        img {
            width: 100%;
            height: 100%;
        }
    }

    .notice_fixed {
        position: fixed;
        top: 0;
        left: 0;
        width: 100vw;
        height: 100vh;
        background: rgba(0, 0, 0, 0.5);
        z-index: 2006;

        .notic_fixed_bottom {
            position: absolute;
            bottom: 0;
            left: 0;
            width: 750px;
            height: 738px;
            background: #ffffff;
            box-shadow: 0px 8px 32px 0px rgba(0, 0, 0, 0.08);
            border-radius: 16px;
            padding: 74px 70px 0;
            font-size: 26px;
            font-weight: 400;
            line-height: 48px;
            color: #666666;

            div {
                position: absolute;
                top: -56px;
                right: 48px;
                font-size: 28px;
                color: #ffffff;
            }
        }
    }

    .submit {
        position: fixed;
        bottom: 0px;
        left: 0px;
        width: 750px;
        height: 260px;
        background: #ffffff;
        box-shadow: 0px 8px 32px 0px rgba(0, 0, 0, 0.08);
        border-radius: 24px 24px 0px 0px;
        z-index: 10;

        .submit-checkout {
            width: 100%;
            height: 28px;
            margin-top: 40px;
            padding-left: 48px;
            display: flex;
            align-items: center;

            .icon {
                margin-left: 16px;
            }
        }

        .submit-btn {
            width: 686px;
            height: 72px;
            background: #355d4b;
            border-radius: 36px;
            color: #ffffff;
            font-size: 24px;
            font-weight: 500;
            display: flex;
            justify-content: center;
            align-items: center;
            margin: 32px auto 0 auto;
        }
    }

    .pd7 {
        padding: 48px 0 600px !important;
    }

    .main-content {
        width: 718px;
        height: auto;
        background: #ffffff;
        border-radius: 24px 24px 0px 0px;
        margin: 0 auto;
        padding: 48px 0 260px;

        .main-content-explain {
            width: 622px;
            height: 144px;
            font-size: 26px;
            color: #666666;
            margin: auto;
            line-height: 48px;
            text-indent: 60px;
        }

        .check-agree {
            width: 100%;
            height: 35px;
            margin-top: 64px;
            padding-left: 48px;
            padding-right: 48px;
            display: flex;

            input {
                width: 32px;
                height: 32px;
            }
        }

        .underline {
            width: 622px;
            height: 1px;
            background: #efefef;
            margin: 48px auto;
        }

        .main-content-hint {
            width: 626px;
            height: 64px;
            background: #ffeee5;
            border-radius: 16px;
            display: flex;
            align-items: center;
            justify-content: center;
            margin: auto;

            .hing-img {
                position: relative;
                width: 50px;
                height: 45px;
                margin-right: 8px;
                margin-left: -10px;
                background: url("../../../../assets/images/user/house/dengpao.png")
                    no-repeat;
                background-size: 50px 45px;
            }

            span {
                font-size: 22px;
                color: #ff9d36;
            }
        }

        .main-content-instructions {
            width: 626px;
            height: auto;
            margin: 64px auto 0 auto;

            .declare {
                font-size: 28px;
                font-weight: 500;
            }

            .five-stars {
                width: 100%;
                height: 46px;
                margin-top: 28px;
                display: flex;
                align-items: center;

                span {
                    font-size: 24px;
                    color: #dddddd;
                    margin-left: 40px;
                }
            }

            .label {
                width: 100%;
                height: auto;
                background: #fff;
                margin-top: 32px;

                // overflow-x: scroll;
                // white-space: nowrap;
                span {
                    width: fit-content;
                    display: inline-block;
                    font-size: 24px;
                    color: #666666;
                    padding: 15px 15px;
                    // line-height: 20px;
                    border: 1px solid #dddddd;
                    border-radius: 16px;
                    margin-right: 16px;
                    margin-bottom: 16px;
                    font-weight: 400;
                }
            }
        }

        .mt48 {
            margin: 48px auto 0 auto !important;
        }

        .text-voice-evaluate {
            width: 100%;
            //height: calc(224px + 28px + 32px);
            height: auto;
            margin-top: 64px;

            .text-voice-evaluate-title {
                width: 100%;
                height: 32px;
                font-size: 28px;
                padding: 0 48px;
                color: #d6d6d6;
                font-weight: 500;

                span {
                    margin-right: 40px;
                }
            }

            .text-voice-evaluate-content {
                width: 654px;
                height: 224px;
                border-radius: 16px;
                border: 1px solid #dddddd;
                margin: 0 auto;
                margin-top: 32px;
                padding: 40px 32px;

                .text {
                    width: 100%;
                    height: 100%;
                    font-size: 28px;
                    line-height: 44px;
                    overflow: scroll;

                    &::-webkit-input-placeholder {
                        color: #dddddd;
                    }
                }

                .recording-voice {
                    width: 160px;
                    height: auto;
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    margin: 0 auto;

                    .recording-voice-btn {
                        width: 112px;
                        height: 112px;
                        background: #f5f7f6;
                        border-radius: 100%;
                        margin-bottom: 16px;
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        background: url("../../../../assets/images/user/house/yuyin-da.png")
                            no-repeat;
                        background-size: 112px 112px;
                    }

                    span {
                        color: #999999;
                        font-size: 20px;
                    }
                }

                .play-voice {
                    position: relative;
                    width: 100%;
                    margin-top: 40px;
                    height: 88px;
                    background: #f5f7f6;
                    border-radius: 44px;
                    display: flex;
                    align-items: center;
                    padding: 0 48px 0 24px;
                    color: #355d4b;
                    font-size: 24px;

                    .play-voice-fish {
                        width: 48px;
                        height: 48px;
                        background: url("../../../../assets/images/user/house/yuyin-play.png")
                            no-repeat;
                        background-size: 48px 48px;
                        margin-right: 8px;
                    }

                    .voice-icon {
                        width: 18px;
                        height: 24px;
                        background: url("../../../../assets/images/user/house/yuyin-xiao.png")
                            no-repeat;
                        background-size: 18px 24px;
                    }

                    .delete {
                        margin-left: auto;
                    }

                    .wire {
                        margin: 0 24px 0 22px;
                    }

                    .play-voice-text {
                        position: absolute;
                        bottom: -48px;
                        left: 50%;
                        transform: translateX(-50%);
                        font-size: 20px;
                        color: #999999;
                    }
                }
            }
            .text-voice-evaluate-content-before{
                height: 300px;
            }
            .text-voice-evaluate-content-after{
                height: auto;
            }
        }

        .image-uploading {
            width: 654px;
            height: auto;
            margin: 76px auto 0 auto;

            .image-uploading-title {
                width: 100%;
                height: 32px;
                font-size: 28px;
                color: #333333;
                line-height: 28px;
                margin-bottom: 32px;
                font-weight: 500;
                margin-left: 16px;
                display: flex;
                justify-content: space-between;
                align-items: center;
                padding-right: 50px;
                .photo-img{
                    font-size: 28px;
                    color: #83A594;
                    display: flex;
                    align-items: center;
                    img{
                        margin-left: 6px;
                        width: 8px;
                        height: 14px;
                    }
                }
            }
        }
    }
}
</style>
